import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var SchoolOutlineSVG = function SchoolOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29,28H28V22h1a1,1,0,0,0,0-2H20.53C22.72,18,24,13.45,24,12a4.83,4.83,0,0,0-4.94-5A5.54,5.54,0,0,0,17,7.55V7a.92.92,0,0,1,1-1,1,1,0,0,0,0-2,2.91,2.91,0,0,0-3,3v.55A5.54,5.54,0,0,0,12.94,7,4.83,4.83,0,0,0,8,12c0,1.45,1.28,6,3.47,8H5a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3H29a1,1,0,0,0,0-2ZM10,12a2.84,2.84,0,0,1,2.94-3,4.67,4.67,0,0,1,1.64.57A2.86,2.86,0,0,0,16,9.93a2.79,2.79,0,0,0,1.41-.36A4.78,4.78,0,0,1,19.06,9,2.84,2.84,0,0,1,22,12c0,1.83-2.12,7-3.67,7a2.4,2.4,0,0,1-.84-.33,2.85,2.85,0,0,0-3,0,2.61,2.61,0,0,1-.84.33C12.12,19,10,13.83,10,12ZM26,28H4.89a1,1,0,0,1,0-2H26Zm0-4H5a1,1,0,0,1,0-2H26Z"
  }));
};
SchoolOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SchoolOutlineSVG);